import { loadSprites } from '../engine/assetLoader';
import { Key } from '../engine/enums';
import { Renderable } from '../engine/renderable';
import Vector2d from '../engine/vector2d';
import Entity from '../entity';
import State from '../state';
import { createHiScoreEntry, getScores, readScores, writeScores, HiScoreEntry } from '../store';
import TextRenderer, { Color, FontSize } from '../text';
import TextInput, { InputState } from '../textInput';

import { RenderableScreen, Screen, ScreenManager } from './screenManager';

export default class IntroScreen implements RenderableScreen {
  name = 'IntroScreen';

  private readonly width: number;
  private readonly height: number;
  private readonly screenManager: ScreenManager;

  private gameObjects: Renderable<State>[] = [];
  private textRenderer: TextRenderer | undefined;

  constructor(screenManager: ScreenManager) {
    this.screenManager = screenManager;
    this.width = screenManager.width;
    this.height = screenManager.height;
  }

  onPlayerInput(player: Entity, key: Key): void {
    this.screenManager.setScreen(Screen.HighScore);
  }

  initScreen(state: State): void {
    state.reset();
    this.gameObjects = [];

    loadSprites([
      'font'
    ])
      .then(sprites => {
        this.textRenderer = new TextRenderer(sprites.find(s => s.name === 'font'));
        this.update(0, state);
      });
  }

  update(gameTime: number, state: State): void {
    if (gameTime % 2 === 0) {
      this.gameObjects.forEach(obj => obj.update(gameTime, state));
    }

    if (gameTime > 100) {
      this.screenManager.setScreen(Screen.HighScore);
    }
  }

  render(_: State, gameTime: number, ctx: CanvasRenderingContext2D): void {
    ctx.fillStyle = '#000';
    ctx.fillRect(0, 0, this.width, this.height);

    this.textRenderer?.renderText(`Pac Man Arena`, FontSize.Large, Color.Yellow, new Vector2d(22.5, 12), ctx);
    this.textRenderer?.renderText(`By Oscar Wallhult`, FontSize.Normal, Color.White, new Vector2d(23.6, 34), ctx);

    ctx.save();
  }
}
